import React from "react";
import { HyroTable } from "@hyro-components";
import { PRODUCTS_TABLE_COLUMNS } from "./SubscriptionTab.consts";

const ProductsTable = ({ products }) => {
  const rows = products.map((product, index) => ({
    id: index,
    name: product.name
  }));

  return (
    <HyroTable
      columns={PRODUCTS_TABLE_COLUMNS}
      rows={rows}
      showPagination={products.length > 0}
      noRowsText="Product data is not yet available. It will appear here once updated."
      noRowsTextSx={{
        maxWidth: 250,
        textAlign: "center"
      }}
      minHeight={250}
    />
  );
};

export default ProductsTable;
